import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CompanyPrivateRoute = ({ children }) => {
  const { isCompanyAuthenticated } = useAuth();
  const storedAuth = JSON.parse(localStorage.getItem('isCompanyAuthenticated'));

  return storedAuth ? children : <Navigate to="/login" />;
};

export default CompanyPrivateRoute;
